export default __webpack_public_path__ + "static/media/logo-netflix.432ed6b5.svg";